module.exports = __webpack_public_path__ + "static/media/logo.e70bb300.svg";